import { API } from '@apis/API';
import { axiosInstance } from 'src/axios/useRequest';

/** 3.1 거래등록 요청 바디 */
export interface PaymentRequestInterface {
  bnameList: string;
  bname: string;
  btel: string;
  bemail: string;
  dest: string;        // 국가 코드
  embassyCode: string; // 대사관 코드
  pay_method: string;   // 'CARD' 등
  ordr_idxx: string;    // 주문번호
  reg_type: string;     // 'web' | 'mobile'
  good_mny: string;     // 숫자만
  good_name: string;
  insurcYn: string;
  gogreenYn: string;
  ret_URL: string;
  fail_url: string;
}

/** 3.1 거래등록 응답 (대소문자/스네이크 혼재 대비) */
export interface PaymentTregResponse {
  code?: string;
  Code?: string;
  message?: string;
  Message?: string;

  pay_url?: string;
  payUrl?: string;
  PayUrl?: string;

  approvalKey?: string;
  approval_key?: string;

  traceNo?: string;
  paymentMethod?: string;

  // (백엔드 호환용 필드)
  redirectUrl?: string;
  status?: string;
}

/** 3.1 거래등록 호출 */

export const submitPayment = async (
  paymentData: PaymentRequestInterface
): Promise<PaymentTregResponse> => {
  try {
    const { endpoint } = API.PAYMENT_TREG;
    const res = await axiosInstance.post(endpoint, { ...paymentData });
    return res.data as PaymentTregResponse;
  } catch (error: any) {
    console.error('=== 결제 API 에러 ===');
    console.error('에러:', error);
    console.error('응답:', error?.response?.data);
    throw error;
  }
};

/** 응답 정규화 헬퍼 */
export const getPayUrl = (res: PaymentTregResponse): string | undefined =>
  res.pay_url || res.payUrl || res.PayUrl || res.redirectUrl;

export const getApprovalKey = (res: PaymentTregResponse): string | undefined =>
  res.approval_key || res.approvalKey;
